export default __webpack_public_path__ + "static/media/BackOffice.b46ec521.png";